import React, {useState} from "react";
import "react-datepicker/dist/react-datepicker.css";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
//import slices
import {useDispatch} from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import {bgItemTypes,} from "../../../db/models/const";
import {closeDialog} from "../../../slices/dialog";
import {updateRmBgItem} from "../../../api/common";
import {sanitizeUrl} from "../../../helpers/misc";
import "../../CommonComponents.scss";
import TextEditor from "../../../common/components/TextEditor/main";

export const EditRmMaterial = ({material, docId}) => {
    const [loading, setLoading] = useState(false);
    const {register, handleSubmit, errors} = useForm({
        defaultValues: {
            title: material?.title || "",
            link: sanitizeUrl(material?.link) || "",
        }
    });
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [description, setDescription] = useState(material?.description || "");

    const onSave = (data) => {
        let mat = {...material};

        mat = {
            ...mat,
            title: data.title,
            link: sanitizeUrl(data.link),
            description,
        };

        setLoading(true);
        updateRmBgItem(docId, bgItemTypes.MAT, mat, !material)
            .then(() => {
                setLoading(false);
                dispatch(closeDialog());
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    };

    return (
        <div className="editBgMaterial bg-dialog">
            <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("company_rm_editMat_name_label")}</div>
                    <input
                        name="title"
                        type="text"
                        ref={register({required: true})}
                    ></input>
                    {errors.title && <p>{t("company_rm_editMat_name_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editMat_link_label")}</div>
                    <textarea
                        name="link"
                        type="text"
                        ref={register({required: true})}
                    ></textarea>
                    {errors.link && <span>{t("company_rm_editMat_link_error")}</span>}
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editMat_desc_label")}</div>
                    <TextEditor
                        editorStyle={{minHeight: "150px"}}
                        placeholder={""}
                        defaultValue={description}
                        HTMLvalueOnChangeCB={setDescription}/>
                </div>
                {!loading && <input type="submit" value={t("company_rm_editMat_submit")}></input>}
                {loading && (
                    <div className="loader">
                        <ClipLoader size={20} color={"#7400b8"} loading={true}/>
                    </div>
                )}
            </form>
        </div>
    );
};